// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__bb37i","Tag--Red":"Tag_Tag--Red__XntJQ","Tag--Black":"Tag_Tag--Black__zZe_o","Tag--Green":"Tag_Tag--Green__NmuMK"};